import React from 'react';
import { ReactFuri } from 'react-furi';
import WordWithFurigana from './WordWithFurigana';

const Oracion = ({
    data, 
    verTraduccion, 
    verDesglose, 
    verFurigana,
    verRomaji,
    handleClickSegmento, 
    indice,
    destacado
}) => {
    
    return (
        <div className={`text-4xl   ${verTraduccion ? "mb-1" : "mb-6"} ${verDesglose ? 'cursor-pointer' : 'cursor-default'}`}>
        {data.jp.segments.map((segment, indexSegmento) => {
            const segmentId = `oracion_${indice}_segmento${indexSegmento}`;
            const isActive = destacado === segmentId;
            return (
            <React.Fragment key={indexSegmento}>
                <div 
                    data-segment-id={segmentId}
                    className={`inline-flex items-end 
                                ${
                                    verDesglose 
                                        ? `hover:text-japanese-cherry hover:scale-105 hover:drop-shadow-lg ${
                                            isActive ? 'text-japanese-cherry scale-105 drop-shadow-lg' : ''
                                          }`  
                                        : ''
                                } `} 
                    onClick={(e) => handleClickSegmento(e, segment.explanation, segmentId)}>
                        {segment.words.map((word, indexWord) => (
                            <div style={{position: "relative"}} className='inline-block' key={indexWord}>
                                <WordWithFurigana 
                                        key={indexWord}
                                        word={word}
                                        verFurigana={verFurigana}
                                        verRomaji={verRomaji}
                                    />
                            </div>
                        ))}
                </div>
                {verDesglose && indexSegmento < data.jp.segments.length - 1 && "　"}
            </React.Fragment>
            )
        })}

        
    </div>
    );
};

export default Oracion;